import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function UserListHeader() {
  const { t } = useTranslation();

  return (
    <Typography variant="h6" component="h2" p={1}>
      {t('userAccessControl.title')}
    </Typography>
  );
}
